module.exports = __webpack_public_path__ + "img/cta-sport-nl.04cc52d0.png";